module.exports = __webpack_public_path__ + "img/menu2.62aa48ec.png";